import { criarAtendimentoService } from '../services/atendimentos_base.service';
export { STATUS_API } from '../services/atendimentos_base.service';
var service = criarAtendimentoService('atendimentos-acolhimento');
export var cadastrarAtendimento = service.cadastrarAtendimento;
export var getAtendimentos = service.getAtendimentos;
export var getAtendimento = service.getAtendimento;
export var getReeducando = service.getReeducando;
export var getCombosListar = service.getCombosListar;
export var getCombosCadastro = service.getCombosCadastro;
export var alterarAtendimento = service.alterarAtendimento;
export var excluirAtendimento = service.excluirAtendimento;
export var gerarExcelAtendimentos = service.gerarExcelAtendimentos;
export var gerarPDFAtendimentos = service.gerarPDFAtendimentos;
